// extracted by mini-css-extract-plugin
export var cardHeader = "_h1-0";
export var reorderHandle = "_h1-3";
export var titleArea = "_h1-1";
export var titleAreaWithHandle = "_h1-2";